module.exports = __webpack_public_path__ + "static/farrier-9befa313734f8c746d69191e4a2b264d.jpg";